module.exports = __webpack_public_path__ + "static/media/6.dd196bb6.png";